

import { NgModule } from '@angular/core';
import { TnxSharedModule } from 'tnx-shared';
import { EventFormComponent } from './event-form/event-form.component';
import { EventComponent } from './event.component';
import { EventRoutes } from './event.routing';

export function declaration() {
    return [EventComponent, EventFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class EventModule {
}

@NgModule({
    imports: [EventModule, EventRoutes],
    exports: [EventModule]
})
export class EventWithRouteModule {
}
